import React from 'react';
import { useTableSelector } from 'hooks/useTableSelector';

import chipStyles from 'components/UserActions/SitOutOverlay.module.scss';

import { useSitGoGoToLobby, useSitGoResultEntry } from './useSitGoResult';

import styles from './SitGoResult.module.scss';

/**
 * EN-11109: the felt after the Sit & Go result modal is dismissed. A sibling of
 * SitOutOverlay rather than a mode of it — that one renders only for a seated
 * player, and a finished player no longer holds a seat.
 *
 *  - Finished table: a big "Go to lobby" chip in the I'm Back treatment (same
 *    chip, same breathing animation), which leaves the table the way No does
 *    and lands on the lobby's Sit & Go tab (useSitGoGoToLobby).
 *  - Busted on a table still in play: nothing. The player is an observer, with
 *    the table's own Exit Table and menu.
 *
 * There is no way back to the modal from the felt: the reopen line comes with
 * EN-11303. The layer is pointer-transparent outside the chip, so the footer's
 * Hand History and Chat and the header menu stay reachable.
 */
const SitGoFinishedOverlay = () => {
  const entry = useSitGoResultEntry();
  const goToLobby = useSitGoGoToLobby();
  const tableStatusFinished = useTableSelector((table) => table.game?.status === 'F');

  // EN-11310: a successful rematch leaves this table once the view has moved
  // to the next one; until then it is not a table to go to the lobby from.
  if (!entry || entry.modalOpen || entry.registrationOpen || entry.rematchRegistered) return null;
  if (!entry.tableFinished && !tableStatusFinished) return null;

  return (
    <div className={styles.feltWrap}>
      <button
        type='button'
        className={chipStyles.button}
        onClick={() => goToLobby(entry.outcome.capacity)}
        aria-label='Go to lobby'>
        <span className={chipStyles.pulse} aria-hidden />
        <span className={`${chipStyles.pulse} ${chipStyles.pulseDelay}`} aria-hidden />
        <span className={chipStyles.core}>
          <span className={`${chipStyles.label} ${styles.goToLobbyLabel}`}>Go to lobby</span>
        </span>
      </button>
    </div>
  );
};

export default SitGoFinishedOverlay;
